import CreatePageDialog from "@/components/applications/page/CreatePageDialog.vue";
import EditPageDialog from "@/components/applications/page/EditPageDialog.vue";
import DeletePageDialog from "@/components/applications/page/DeletePageDialog.vue";
import SearchInput from "@/components/global/SearchInput.vue";

export default {
  name: "Pages",

  data: () => ({
    search: "",
    headers: [
      {
        text: "Aplicaciones",
        value: "app_name",
        align: "start",
        sortable: false,
        class: "primary--text",
      },
      {
        text: "Módulo",
        value: "module_name",
        align: "start",
        sortable: false,
        class: "primary--text",
      },
      {
        text: "Nombre",
        value: "name",
        align: "start",
        sortable: false,
        class: "primary--text",
      },
      {
        text: "Descripción",
        value: "description",
        sortable: false,
        class: "primary--text",
      },
      {
        text: "Estado",
        value: "active",
        align: "center",
        sortable: false,
        class: "primary--text",
      },
      {
        text: "Acciones",
        value: "actions",
        sortable: false,
        class: "primary--text",
      },
    ],
    editedItem: {},
    deletedItem: {},
    currentPage: 1,
    applicationSelected: null,
    moduleSelected: null,
    timeout: null,
    limit: 5,
    rowsPerPage: [{ value: 5 }, { value: 10 }, { value: 15 }, { value: 20 }, { value: 25 }, { value: 30 }]
  }),

  computed: {
    pages() {
      return this.$store.getters["pages/getPages"];
    },
    widthPage() {
      return this.$vuetify.breakpoint.width;
    },
    paginationPages() {
      return this.$store.getters["pages/getPaginationPages"];
    },
    applicationItems() {
      return this.$store.getters["applications/getApplicationsList"];
    },
    moduleItems() {
      return this.$store.getters["modules/getModulesList"];
    },
    isLoading() {
      return this.$store.state.pages.isLoading;
    },
  },

  watch: {},

  created() {
    this.$store.dispatch("pages/getPages", { page: 1, limit: 5 });
    this.$store.dispatch("pages/updateCurrentPage", 1);
    this.$store.dispatch("applications/getApplicationsList");
  },

  methods: {
    editItem(item) {
      this.editedItem = { ...item };
    },

    deleteItem(item) {
      this.deletedItem = { ...item };
    },

    listenApplication() {
      this.currentPage = 1;
      this.moduleSelected = null;
      this.search = "";
      this.$store.dispatch("modules/getModulesList", {
        app_id: this.applicationSelected,
      });
      this.$store.dispatch("pages/getPages", {
        page: 1,
        app_id: this.applicationSelected,
      });
    },

    listenModule() {
      this.currentPage = 1;
      this.search = "";
      this.$store.dispatch("pages/getPages", {
        page: 1,
        app_id: this.applicationSelected,
        module_id: this.moduleSelected,
      });
    },

    listenPagination() {
      this.$store.dispatch("pages/getPages", {
        page: this.currentPage,
        app_id: this.applicationSelected,
        module_id: this.moduleSelected,
        search: this.search,
        limit: this.limit
      });
      this.$store.dispatch("pages/updateCurrentPage", this.currentPage);
    },

    resetFilter() {
      this.search = "";
      this.moduleSelected = null;
      this.applicationSelected = null;
      this.currentPage = 1;
    },
  },
  components: {
    CreatePageDialog,
    EditPageDialog,
    DeletePageDialog,
    SearchInput,
  },
};
